export default {"src":"/_next/static/image/public/images/ic_referral_profile.c738a47d6e386bcfec0b1a096b66c672.svg","height":150,"width":142};